// @flow

import MobileDeviceNotice from './MobileDeviceNotice';

export default MobileDeviceNotice;
